export default "__VITE_ASSET__a689331c__"